// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// RxJS
import { Observable } from 'rxjs';
// CRUD
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../../core/_base/crud';
// Models
import { BehaviorSubject } from 'rxjs';
const API_SURVEY_URL = '/api/survey';

@Injectable()
export class CustomerSurveyService {
  private activeComponent: string | null = null;
  private projectTitleSource = new BehaviorSubject<string>('');
  projectTitle$ = this.projectTitleSource.asObservable();
  setActiveComponent(componentName: string) {
    this.activeComponent = componentName;
  }

  getActiveComponent() {
    return this.activeComponent;
  }


  constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {
  }

  // CREATE =>  POST: add a new customer to the server
  createSurvey(survey: any): Observable<any> {
    console.log("survey",survey);
    // Note: Add headers if needed (tokens/bearer)
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http.post<any>(API_SURVEY_URL, survey, {headers: httpHeaders, responseType: 'text' as 'json'});
  }

  // READ
  getAll(): Observable<any[]> {
    return this.http.get<any[]>(API_SURVEY_URL);
  }





}
